import {Button, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'

const AttachmentPill = ({icon, text, attachmentDownloadPath}) => {
  const downloadUrl = new URL(attachmentDownloadPath, window.location.origin)

  return (
    <Button
      as="a"
      alignItems="center"
      bg="neutral.200"
      border="1px solid"
      borderColor="neutral.500"
      borderRadius="md"
      p={1}
      gap={1}
      cursor={downloadUrl ? 'pointer' : 'default'}
      href={`${downloadUrl.toString()}`}
      _hover={downloadUrl ? {bg: 'neutral.300'} : {}}
    >
      {icon}
      <Text fontSize="sm">{text}</Text>
    </Button>
  )
}

AttachmentPill.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  attachmentDownloadPath: PropTypes.string.isRequired,
}

export default AttachmentPill
